<script>

    import { location } from 'svelte-spa-router'

    import EnumMethods from '../$methods/enum.methods'

    import MenuMain from '../$layouts/menu.main.svelte'
    import Tabs from '../$components/tabs.svelte'

    import UserView from './user.view.svelte'
    import UserLocationsView from './user.locations.view.svelte'
    import UserPackagesView from './user.packages.view.svelte'
    import UserMerchandisesView from './user.merchandises.view.svelte'

    $: $location && (selected = params.tab || 'user')

    export let params = {}
    let selected = null

</script>

<MenuMain />

<div class="container">
    <div class="title is-3">Configuración / { EnumMethods.get(selected) }</div>
    <hr>
    <Tabs bind:selected={selected}
        options={[
            {href: '/settings/user', value: 'user', text: 'Usuario', icon: 'id-card'},
            {href: '/settings/locations', value: 'locations', text:'Direcciones', icon: 'address-book'},
            {href: '/settings/packages', value: 'packages', text:'Paquetes', icon: 'box-open'},
            {href: '/settings/merchandises', value: 'merchandises', text:'Mercancias', icon: 'tags'},
        ]} 
    />
    {#if selected === 'user'}
        <UserView />
    {:else if selected === 'locations'}
        <UserLocationsView />
    {:else if selected === 'packages'}
        <UserPackagesView />
    {:else if selected === 'merchandises'}
        <UserMerchandisesView />
    {/if}
</div>